import { KbChapterPage } from "@/components/kb/KbChapterPage";

export function Chapter033() {
  return <KbChapterPage slug="chapter-033" />;
}

(Chapter033 as unknown as { path: string }).path = "/theory-album/033";
